import React from "react"
import { useNavigate } from "react-router-dom"

import * as Commands from "../../../../../../model/commands"
import { ID, Idea, WebSource } from "../../../../../../model/types"
import { useNana } from "../../../../../hooks/useNana"

import ShowEditor from "../../../mosaic_page/idea_pane/show_editor"

import Hub from "../../../../../../hub"
import { HelpInline } from "../../../../../components/help_bubble"
import { MosaicPageState } from "../../../mosaic"

export const LiteratureNotesState: {
  scrollTopForSources: Map<ID, number>
} = {
  scrollTopForSources: new Map<ID, number>(),
}

export default function LiteratureNotes({ source }: { source: WebSource }) {
  const { commander } = useNana()
  const navigate = useNavigate()

  return (
    <>
      <div className="min-h-0 flex flex-col justify-start dark:divide-gray-700 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-800">
        <ShowEditor
          objectKey={source.id}
          initialContent={source?.literatureNotes || ""}
          initialScrollTop={LiteratureNotesState.scrollTopForSources.get(source.id)}
          placeholderText="Notes on and from this source..."
          onPageLinkClick={(idea: Idea) => {
            MosaicPageState.forceOpenLocation = idea.location
            navigate("/app")
          }}
          onUpdate={(newContent, _newSelectionPos) => {
            commander.exec(
              new Commands.SetWebSourceFieldCommand({
                id: source.id,
                field: "literatureNotes",
                value: newContent,
              })
            )
          }}
          onScroll={(scrollTop: number) =>
            LiteratureNotesState.scrollTopForSources.set(source.id, scrollTop)
          }
          recreateWhen={(hub: Hub, recreate): string[] => {
            const k = hub.on("model:source-updated", ({ id, fields, originator }) => {
              if (
                id === source.id &&
                fields.hasOwnProperty("literatureNotes") &&
                originator !== "editor"
              ) {
                recreate()
              }
            })
            return [k]
          }}
        />
      </div>
      {blankContent(source.literatureNotes) && (
        <HelpInline title="">
          <NotesHelp />
        </HelpInline>
      )}
    </>
  )
}

const NotesHelp = () => {
  return (
    <div className="">
      <p>Take two kinds of notes from each source:</p>
      <ol>
        <li>
          <p>
            <strong>Literature notes</strong>: take these as you read. Write down notes on the topic
            of the source, and the contents, but also your own thoughts on the author's ideas.
          </p>
        </li>
        <li>
          <p>
            <strong>Mosaic notes</strong>: from the literature notes extract a set of ideas that can
            be permanently placed into the mosaic.
          </p>
        </li>
      </ol>
      <p>Once you're done, mark the source as Read, which archives it.</p>
    </div>
  )
}

const blankContent = (content: string | null | undefined) =>
  content == null || content == undefined || content == "" || content == "<p></p>"
